//% Observe all transition elements
observe_all();

//# Function that observe all elements with the transition class
function observe_all() {
  const elements = document.querySelectorAll(".transition");

  // console.log(elements);

  if (!elements) {
    console.log("No transition elements found");
    return;
  }

  //# Invert the positive/negative value of the data property to avoid using negative values in dataset
  function invertNegative(input_string) {
    return input_string.includes("-")
      ? input_string.replace("-", "")
      : "-" + input_string;
  }

  //% Create observer for each transition element
  elements.forEach((el) => {
    //) Valid data attributes
    //* data-start
    //* data-end
    //* data-intersection
    //* data-transition
    //* data-speed
    //* data-delay
    //* data-repeat

    //^ Set variables
    //$ Set trigger start point it was set in attribute else use default of 0% which is bottom of screen
    let trigger_start = el.dataset.start
      ? invertNegative(el.dataset.start)
      : "0%";

    //$ Set trigger end point it was set in attribute else use default of 0% which is top of screen
    const trigger_end = el.dataset.end ? invertNegative(el.dataset.end) : "0%";

    //$ Set intersection_point if it was set in data attribute else use default of 0 which is top point of element
    const intersection_point = el.dataset.intersection
      ? parseFloat(el.dataset.intersection)
      : 0;

    //$ If transition atrribute exist set it otherwise make it null
    const transition_speed = el.dataset.transition ? el.dataset.transition : null;
    console.log(transition_speed);

    //$ If delay atrribute exist set speed otherwise make it empty
    const delay = el.dataset.delay ? el.dataset.delay : "";

    //$ If element has a data-repeat attribute, set repeat to false else true
    const repeat = el.dataset.hasOwnProperty("repeat") ? true : false;

    //% Set element transition speed if it was set in data attribute
    if (transition_speed) {
      el.style.transition = transition_speed;
    }

    //^ Create intersection observer
    let observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          //$ Add trigger class to elements while intersecting and remove if not
          entry.target.classList.toggle("show", entry.isIntersecting);

          //$ Disconnect observer once triggered (should be default to avoid slow pages)
          if (!repeat && entry.isIntersecting) {
            // observer.unobserve(entry.target);
            console.log("disconnecting");
            observer.disconnect();
            observer = null;
          }
        });
      },
      {
        root: null,
        rootMargin: `${trigger_end} 0px ${trigger_start} 0px`,
        threshold: intersection_point,
      }
    );

    //^ Observe element
    observer.observe(el);
  });
}

//# Function that observe a specified element based on selector
function observe_element(
  target_selector,
  repeat = false,
  trigger_start = "0%",
  intersection_point = 0, //0 start, 1 end
  speed = null,
  animation_class = null,
  trigger_end = "0%",
  toggle_class = "show"
) {
  const trigger_elements = document.querySelectorAll(target_selector);

  if (!trigger_elements) {
    return;
  }

  //% Observer options
  const options = {
    //? The element that is used as the viewport for checking visibility of the target. root = document element
    root: null,

    //? Margin around the root. Sets the intersection point on root element.
    //? top right bottom left
    rootMargin: `${trigger_end} 0px ${trigger_start} 0px`,

    //? How much of the element needs to come into view 0 = edge, 1 = full element
    threshold: intersection_point,
  };

  //% Create new intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      //$ Add show class to elements when intersecting and remove if not
      entry.target.classList.toggle("show", entry.isIntersecting);

      //$ Unobserve element once triggered
      if (!repeat && entry.isIntersecting) {
        observer.unobserve(entry.target);
      }
    });
  }, options);

  //% Loop through elements and link to observer
  trigger_elements.forEach((el) => {
    //$ Add animation class to element if specified
    if (animation_class) {
      el.classList.add(animation_class);
    }

    //$ Observe element
    observer.observe(el);

    //$ Add custom transition speed if it was specified
    if (speed) {
      console.log("speed being set");
      el.style.transition = `all ${speed} ease-in-out`;
    }
  });
}
